import { useNavigate } from "react-router-dom";
import NoData from "../../assets/img/nodata_gray.svg"
import { useEffect } from "react";
import AppSpinner from "../elements/AppSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import useDataSources from "../../hooks/useDataSources";
import { formatDate } from "../../helpers/commons";

const DataSourcePage = () => {
    const navigate = useNavigate()
    const {
        loadingDataSources,
        dataSources,
        getDataSources,
    } = useDataSources();

    useEffect(() => {
        getDataSources();
    }, []);


    return (
        <div>
            <div className="card">
                <div className=" card-body min-h-half-screen">
                    <div className="flex">
                        <nav className="flex justify-between " aria-label="Breadcrumb">
                            <ol className="inline-flex items-center mb-3 sm:mb-0">
                                <li>
                                    <div className="flex items-center">
                                        <h5 className=" card-title ">Data Sources</h5>
                                    </div>
                                </li>

                            </ol>
                        </nav>
                        <div className="flex-grow flex justify-end">
                            <button onClick={() => navigate("/create-data-sources")} type="button" className="prim-btn-2 mb-2">New Entry</button>
                        </div>
                    </div>

                    {
                        (dataSources.length === 0 && loadingDataSources == false) &&
                        <div className=" h-fit flex-grow flex flex-col justify-center ">
                            <div className="flex justify-center">
                                <div>
                                    <img className=" w-32" src={NoData} alt="" />
                                    <p>No Records Yet!</p>
                                </div>
                            </div>
                        </div>
                    }
                    {(loadingDataSources) && <AppSpinner />}

                    {(dataSources.length > 0) &&
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead>
                                <tr>
                                    <th scope="col" >
                                        Name of MDA
                                    </th>
                                    <th scope="col" >
                                        Website
                                    </th>
                                    <th scope="col" >
                                        Created
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    dataSources.map((item, key) =>
                                        <tr key={key}>
                                            <td>{item.name}</td>
                                            <td>{item.website}</td>
                                            <td>{ item.created_at&&formatDate(item.created_at, "MMM DD, YYYY H:mm")}</td>
                                            <td>
                                                <span onClick={() => navigate("/edit-data-sources/" + item.id)} className=" cursor-pointer">
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    }


                </div>
            </div>
        </div>
    )
}

export default DataSourcePage;